export default "__VITE_ASSET__DfpgwAQa__"